import React from "react";
import cropr from "../../shared/utils/cropr";
import { gettext, interpolate } from "../../shared/utils/legacy";
import { getIconClass } from "../utils";

const getContractWarningCount = (): number => {
  cropr.initContractUtils();
  // eslint-disable-next-line
  return cropr.contract_warnings?.total_urgent_warnings; //camelCase warning
};

export default function DashboardSummaryContract() {
  // - 2 onvoltooide acties voor je contracten (zoals we op registratie hebben)
  /*Only show this block if we have contracts that have a status*/
  const hasContracts =
    cropr.contracts.filter(
      (c) => c.get("contract_status") && c.get("contract_status").contract_status
    ).length > 0;
  const warningCount = hasContracts && getContractWarningCount();
  return (
    (hasContracts && (
      <div className="col-4 col-md py-3">
        <h6 className="text-muted mb-3">{gettext("Contracts")}</h6>
        <a
          href="#contract_status"
          title={gettext("Go to contract status")}
          className="text-black"
          data-metrics_category="summary_widget"
          data-metrics_sub_category="contract_status"
        >
          <i className={getIconClass(warningCount === 0)} />
          &nbsp;
          {interpolate(gettext("%s actions"), [warningCount])}
        </a>
      </div>
    )) ||
    null
  );
}
